import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import slotIcon from '../../../assets/images/snack-shop/slot-icon.png';
import SnackShopFrame from './SnackShopFrame';
import {
  formatWindowLabel,
  maxClaimCount,
  maxSnackCount,
  remainingClaimCount,
  slotPhase,
  toClockValue,
} from './snackShopModel';
import { useSnackCharge, useSnackShopData } from './useSnackShop';

function slotButtonLabel(item, phase) {
  const remaining = remainingClaimCount(item);
  const max = maxClaimCount(item);
  if (phase === 'open' && remaining > 0) return `${remaining}/${max}회 가능`;
  if (phase === 'upcoming') return '오픈 예정';
  return '내일 오픈';
}

export default function SnackShopTimePage() {
  const navigate = useNavigate();
  const { ready, snackCount, slots, refresh } = useSnackShopData();
  const { busy, requestCharge } = useSnackCharge({ snackCount, onCharged: refresh });
  const [now, setNow] = useState(() => toClockValue());
  const timeMaxSnacks = slots.reduce((sum, item) => sum + maxSnackCount(item), 0);

  useEffect(() => {
    const timerId = window.setInterval(() => setNow(toClockValue()), 30000);
    return () => window.clearInterval(timerId);
  }, []);

  const goBackToShop = () => {
    const idx = window.history.state?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
      return;
    }
    navigate('/game/yaong-egg/shop', { replace: true });
  };

  if (!ready) {
    return <section className="min-h-screen w-full bg-[linear-gradient(180deg,#F0ECFF_3.42%,#D0C9FF_100%)]" />;
  }

  return (
    <SnackShopFrame title="야옹 타임 보상" snackCount={snackCount} onBack={goBackToShop}>
      <div className="flex flex-col items-center px-2 pt-4">
        <div className="w-full pb-6 pt-[23px] text-center">
          <p className="m-0 text-[22px] font-bold leading-[1.3]">6시간 간격으로 찾아가는 간식!</p>
          <p className="mb-0 mt-[15px] text-[20px] font-bold leading-[1.4]">
            최대 간식 <span className="text-primary-purple-01">{timeMaxSnacks.toLocaleString()}개</span>
          </p>
        </div>

        <div className="flex w-full flex-col gap-8">
          {slots.length === 0 ? (
            <p className="py-16 text-center text-[15px] font-medium text-gray04">지금은 열려 있는 타임이 없어요.</p>
          ) : null}
          {slots.map((item) => {
            const phase = slotPhase(now, item.startAt, item.endAt);
            const claimable = phase === 'open' && remainingClaimCount(item) > 0;
            const label = slotButtonLabel(item, phase);
            return (
              <article
                key={item.snackShopNo}
                className={`box-border flex h-[90px] w-full items-center gap-3 rounded-[10px] bg-white py-3 pl-4 pr-5 shadow-[0px_6px_12px_rgba(0,0,0,0.08)] ${
                  claimable ? 'border-2 border-solid border-primary-purple-01' : 'border-2 border-solid border-transparent'
                }`}
              >
                <div
                  className={`flex size-12 shrink-0 items-center justify-center rounded-[8px] border border-solid border-[#737373] bg-[#f7f7f7] ${
                    claimable ? '' : 'opacity-50'
                  }`}
                >
                  <img src={slotIcon} alt="" width={30} height={32} className="h-8 w-[30px] object-contain" />
                </div>
                <div className={`flex min-w-0 flex-1 flex-col gap-1 ${claimable ? '' : 'text-[#c9c9c9]'}`}>
                  <p className={`m-0 text-[18px] font-bold leading-normal ${claimable ? 'text-[#222]' : ''}`}>
                    {item.itemName}
                  </p>
                  <p className={`m-0 text-[12px] leading-normal ${claimable ? 'text-gray04' : ''}`}>
                    {formatWindowLabel(item.startAt, item.endAt)}
                  </p>
                </div>
                <button
                  type="button"
                  disabled={!claimable || busy}
                  onClick={() => requestCharge(item.snackShopNo, Number(item.rewardCount) || 0)}
                  className={
                    claimable
                      ? 'flex h-9 shrink-0 items-center justify-center rounded-[8px] border-0 bg-primary-purple-01 px-3 text-[14px] font-semibold text-white disabled:opacity-60'
                      : 'flex h-9 shrink-0 items-center justify-center rounded-[8px] border border-solid border-[#d3d3d3] bg-white px-3 text-[14px] font-semibold text-[#c9c9c9]'
                  }
                >
                  {busy && claimable ? '충전 중' : label}
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </SnackShopFrame>
  );
}
